<template lang="pug">
    v-footer(class="mx-auto" style="background-color:#ffffff;")
        span &copy; {{ new Date().getFullYear() }} - Provided by Digitech - GEMS
    
</template>

<script>
export default {
    name: "Footer",
}
</script>
